import FieldStatus from "../../../../fields3/generic/status/status"
import FieldConfig from "../../../../fields3/proto/field-config"
import ProjectStatusManager from "../../../../gd/manager/project-status-manager"
import ProjectStatus_PopoverMore from "./components/popover/popover-more"
import {ColorPalette, DefaultPaletteColorNumber, ItemColorCoding} from "../../../color-coding/color-coding"
import FieldProjectStatus_TableCell from "./render/table/table-cell"
import Project from "../../../../model2/project/project"
import {FieldFilterType} from "../../../proto/types"
import {
    FieldProjectStatus_filterFunc, FieldProjectStatus_filterValuesFiller
} from "../../../conditions/dropdown"
import Filter from "../../../../manager/filters/manager/filter"
import {
    FieldProjectStatus_filterGetOptions,
} from "../../../conditions/functions/get-filter-options"
import FieldProjectStatus_FilterForm from "./render/condition"
import FieldProjectStatus_TableCellCalculated from "./render/table/calculated/table-cell-calculated"
import FieldProjectStatus_GlistView from "./render/glist/glist-view"
import FieldProjectStatus_AutomationActionForm from "./render/automation/automation-action-form"
import {SystemStatusOptions} from "../../../../gd/const/system-status"

export default class FieldProjectStatus extends FieldStatus {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel                              = "Project Status"
        this.filterType                             = FieldFilterType.DROPDOWN

        this.isSearchable                           = _.get(config, 'isSearchable', true);

        this.noValueOption                          = false

        this.components.PopoverMenuMore             = ProjectStatus_PopoverMore

        this.renderComponents.tableCell             = FieldProjectStatus_TableCell
        this.renderComponents.tableCellCalculated   = FieldProjectStatus_TableCellCalculated
        this.renderComponents.filterForm            = FieldProjectStatus_FilterForm
        this.renderComponents.glistView             = FieldProjectStatus_GlistView
        this.renderComponents.automationActionForm  = FieldProjectStatus_AutomationActionForm

        this.filterFunc                             = FieldProjectStatus_filterFunc
        this.filterValuesFiller                     = FieldProjectStatus_filterValuesFiller
    }

    canEdit(model: Project): boolean {
        return model.acl.canChangeStatus
    }

    access(model:any) {
        return gd.ac.check.project.fullAccess(model.id) ? 'write' : 'read';
    }

    // when statusId is null, fall back to systemStatus so widgets group/label by system status
    getValue(model: any) {
        return model.statusId || model.systemStatus || _.get(model, this.fieldId, null)
    }

    _getOption(value:any) {

        // try dynamic status
        let status = gd.session.statuses.get(value)
        if (status) {
            return status.exportToOption()
        }

        // fall back to system status (used when project has no custom statusId)
        const systemStatusOption = _.find(SystemStatusOptions, o => o.value == value)
        if (systemStatusOption) return systemStatusOption

        // esli mi popali suda to zopa ... netu status u project chto delat' neponyatno...
        console.error("ERROR #PROJECT-NO-STATUS-1")
    }

    getOptionsForEdit(model:any) {
        const options = ProjectStatusManager.getProjectStatusOptions(model)
        return options
    }

    getOptions() {
        return gd.session.statuses.map((status: any)=> {
            return status.exportToOption()
        })
    }

    getColorCoding(model: any): ItemColorCoding {
        const value  = this.getValue(model)
        const option = this._getOption(value)

        return {
            colorNumber         : option?.color || DefaultPaletteColorNumber.STATUS,
            corePalette         : ColorPalette.STATUS
        }
    }

    async filterGetOptions(filter: Filter): Promise<Option[]> {
        return await FieldProjectStatus_filterGetOptions(this, filter)
    }
}
